import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { githubActionsApiRef } from '@backstage-community/plugin-github-actions';
import { StackPoliciesTechRadarApi } from '@internal/plugin-stack-policies';
import { ProxyGithubActionsClient } from './apis/ProxyGithubActionsClient';
import {
  githubInsightsApiRef,
  ProxyGithubInsightsClient,
} from './apis/ProxyGithubInsightsClient';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // Prefer org GITHUB_TOKEN via proxy so Actions load without extra user OAuth.
  createApiFactory({
    api: githubActionsApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ configApi, discoveryApi, fetchApi }) =>
      new ProxyGithubActionsClient({ configApi, discoveryApi, fetchApi }),
  }),
  // Same for README / Code Insights (avoids org OAuth App access restrictions).
  createApiFactory({
    api: githubInsightsApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ configApi, discoveryApi, fetchApi }) =>
      new ProxyGithubInsightsClient({ configApi, discoveryApi, fetchApi }),
  }),
  createApiFactory({
    api: techRadarApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new StackPoliciesTechRadarApi(discoveryApi, fetchApi),
  }),
];
